let language = {
    "LBL_HOME":"Home",
    "LBL_ADMIN": "Admin",
    "LBL_LANGUAGE": "This Is Language File",
    "LBL_MODULE": "Admin",
    "LBL_SELECT_BRANCH":"Select Branch",
    "LBL_MODULE_NAME":"Module Name",
    "LBL_FIELD":"Field Name",
    "LBL_IDENTIFIERS":"Identifiers / Table Name",
    "LBL_PREFIX":"Prefix",
    "LBL_SEQUENCE":"Sequence",
    "LBL_DATE_FIELD":"Date Field",
    "LBL_PERIOD":"Period",
    "LBL_ACTION":"Action",
    "LBL_ADD_NEW":"Add New",
    "LBL_SYSTEM_CONFIGRATION":"System Configration",
    "LBL_SYSTEM_SETTINGS":"System Settings",
    "LBL_PDF_SETTINGS":"PDF Settings",
    "LBL_SAML_SETTINGS":"SAML Settings",
    "LBL_KEY_NAME":"SAML Key Name",
    "LBL_KEY_LOGIN_URL":"IDP Login URL",
    "LBL_KEY_ENTITY_ID":"IDP Entity ID",//Azure AD Identifier(Entity ID)
    "LBL_KEY_LOGOUT_URL":"IDP Logout URL",
    "LBL_KEY_X509CERTIFICATE":"IDP X509 Certificate",
    "LBL_SAML_SETTINGS_STATUS":"Enable SMAL Authentication",
    "LBL_DEFAULT_SCHEDULER":"Scheduler",
    "LBL_LOCAL_SETTINGS":"Locale Settings",
    "LBL_RPAIR_REBUILD":"Quick Repair and Rebuild",
    "LBL_DATABASE_BACKUP":"Database Backup",
    "LBL_IMPORT_RECORTDS":"Import Records",
    "LBL_UNIQUE_IDENTIFIERS":"Visual Unique Identifiers",
    "LBL_GLOBAL_SETTINGS":"Global Settings",
    "LBL_DELETED_PAYMENTS":"Deleted Payments",
    "LBL_DELETED_BILLINGS":"Deleted Billings",
    "LBL_APPROVAL_SETTINGS":"Approval Settings",
    "LBL_DEFAULT_USER":"Users",
    "LBL_USER_MANAGEMENT":"User Management",
    "LBL_USER_TEMPLATE":"User Template",
    "LBL_USER_LOGGED_IN":"Users Logged In",
    "LBL_DEFAULT_DASHLETS":"User Default Dashlets",
    "LBL_TYPE_GLOBAL_SEARCH":"User Type Global Search",
    "LBL_DEFAULT_EMAIL":"Email",
    "LBL_EMAIL_CONFIG_SUPPORT":"Email Config for Eatpro Support",
    "LBL_EMAIL_SETTINGS":"Email Settings",
    "LBL_SYATEM_WISE_SETTINGS":"System Wise Email Settings",
    "LBL_VIEW_EMAIL":"View Mail",
    "LBL_CREATE_EMAIL_TEMPLATE":"Create Email Template",
    "LBL_VIEW_EMAIL_TEMPLATE":"View Email Template",
    "LBL_USER_REPORTS":"User Reports",
    "LBL_NEW_USER_REPORT":"New User Report",
    "LBL_VIEW_USER_REPORT":"View User Reports",
    "LBL_PDF_REQUESTS":"PDF Requests",
    "LBL_REPORT_AUTHORIZATION":"Report Authorization",
    "LBL_PRINTER_SETTINGS":"Printer Settings",
    "LBL_NEW_PRINTER":"New Printer",
    "LBL_VIEW_PRINTERS":"View Printers",
    "LBL_NEW_PRINT_SETTINGS":"New Print Settings",
    "LBL_VIEW_PRINT_SETTINGS":"View Print Settings",
    "LBL_NEW_PRINT_HEADER":"New Print Header",
    "LBL_VIEW_PRINT_HEADER":"View Print Header",
    "LBL_NEW_PRINT_FOOTER":"New Print Footer",
    "LBL_VIEW_PRINT_FOOTER":"View Print Footer",
    "LBL_NEW_PRINT_SIZE":"New Print Size",
    "LBL_AVAILABLE_PRINT_SIZE":"Available Print Size",
    "LBL_CURRENT_PRINT_SIZE":"Current Print Size",
    "LBL_VIEW_CURRENT_PRINT_SIZE":"View Current Print Size",
    "LBL_DEFAULT_SMS":"Mass SMS",
    "LBL_NEW_ADMISSION_SMS":"New Admission SMS",
    "LBL_VIEW_ADMISSION_SMS":"View Admission SMS",
    "LBL_ADMISSION_SMS_RECIPIENT":"New Admission SMS Recipient",
    "LBL_VIEW_ADMISSION_RECIPIENT":"View Admission SMS Recipient",
    "LBL_ADD_SMS_TEMPLATES":"Add SMS Templates",
    "LBL_VIEW_SMS_TEMPLATES":"View SMS Templates",
    "LBL_CLEAR_JAVASCRIPT_FILES":"Clear Javascript Files",
    "LBL_CLEAR_JAVASCRIPT_LANGS_FILES":"Clear Javascript Language Files",
    "LBL_CLEAR_DASHLET_CACHE_DATA":"Clear Ether Dashlet Cache Data",
    "LBL_CLEAR_LANGS_FILES":"Clear Language Files",
    "LBL_CLEAR_SEARCH_CACHE":"Clear Unified Search Cache",
    "LBL_DEFAULT_USER_INTERFACE":"User Interface",
    "LBL_ENTITES_LISTVIEW_ITEM":"Listview items per page",
    "LBL_ENTITES_DASHLET_ITEM":"Dashletview items per page",
    "LBL_MAX_NUMBER_DASHLET_HOME":"Max Number Dashlets on Home",
    "LBL_SYSTEM_NAME":"System Name",
    "LBL_TOTAL_HEALTH_CHECKUP_DAY":"Total Health Checkup in a Day",
    "LBL_SERVER_RESPONSE_TIMES":"Display server response times",
    "LBL_TABS_LOGIN_SCREEN":"Display tabs on login screen",
    "LBL_SHOW_FULLNAME":"Show Full Name (not Login)",
    "LBL_USER_CUSTOMIZABLE_HOMEPAGE":"Prevent user customizable Homepage layout",
    "LBL_USER_CUSTOMIZABLE_SUBPANEL":"Prevent user customizable subpanel layout",
    "LBL_BILL_GENERATION":"Bill Genaration",
    "LBL_BILL_REQUIRED":"Registration Bill Required?",
    "LBL_ENABLE_DUPLICATE_PRINT":"Enable Duplicate print Functionality?",
    "LBL_DATE_CREATED_MODIFIED":"Date Created and Modified",
    "LBL_SHOW_CREATED_MODIFIED_SYSTEM":"Show Date Created/Modified in System?",
    "LBL_SHOW_CREATED_MODIFIED_USER":"Show Date Created/Modified to User?",
    "LBL_EXTERNAL_KITCHEN":"External Kitchen",
    "LBL_KITCHEN_MANAGED_EXTERNAL":"Kitchen managed by External Contractor?",
    "LBL_INTERNAL_PHARMACY":"Internal Pharmacy",
    "LBL_USER_INTERNAL_PHARMACY":"Hospital uses Internal Pharmacy?",
    "LBL_HOSPITAL_LAVEL_SYSTEM":"Hospital Level System (HL7)",
    "LBL_HOSPITAL_ENABLE_SYSTEM":"Enable HL7?",
    "LBL_HOSPITAL_NAME_ADDRESS":"Hospital Name and Address",
    "LBL_HOSPITAL_NAME":"Name",
    "LBL_HOSPITAL_ADDRESS_1":"Address 1",
    "LBL_HOSPITAL_ADDRESS_2":"Address 2",
    "LBL_HOSPITAL_CITY":"City",
    "LBL_HOSPITAL_STATE":"State",
    "LBL_HOSPITAL_PINCODE":"Pincode",
    "LBL_HOSPITAL_COUNTRY":"Country",
    "LBL_HOSPITAL_PHONE":"Phone",
    "LBL_HOSPITAL_WEBSITE_URL":"Site",
    "LBL_HOSPITAL_FACEBOOK_URL":"Facebook Site",
    "LBL_HOSPITAL_TWITTER_URL":"Twitter Site",
    "LBL_HOSPITAL_YOUTUBE_URL":"Youtube Site",
    "LBL_HOSPITAL_INSTAGRAM_URL":"Instagram Site",
    "LBL_HOSPITAL_WEBLINK":"Privacy Weblink",
    "LBL_HOSPITAL_EMAIL":"E-Mail",
    "LBL_HOSPITAL_SMS_FOOTER":"For SMS Footer",
    "LBL_HOSPITAL_TIN_NUMBER":"TIN Number",
    "LBL_HOSPITAL_GSTIN_NUMBER":"GSTIN No.",
    "LBL_HOSPITAL_PAN_NUMBER":"PAN No.",
    "LBL_DEFAULT_HOSPITAL_CONTACT_ADDRESS":"Hospital Contact Address",
    "LBL_HOSPITAL_CONTACT_ADDRESS":"Contact Address",
    "LBL_DEFAULT_PRINT_HEADER_FOOTER":"Header & Footer in Print",
    "LBL_PRINT_HEADER_FOOTER":"Hospital Header & Footer in Print?",
    "LBL_USER_INTERFACE":"User Interface",
    "LBL_DEFALUT_DATE_FORMAT":"Default Date Format",
    "LBL_DEFALUT_TIME_FORMAT":"Default Time Format",
    "LBL_DEFALUT_LANGUAGE":"Default Language",
    "LBL_DEFALUT_NAME_FORMAT":"Default Name Format",
    "LBL_SAMPLE_EXAMPLE":"Example",
    "LBL_DEFAULT_CURRENCY":"Default Currency",
    "LBL_CURRENCY":"Currency",
    "LBL_CURRENCY_SYMBOL":"Currency Symbol",
    "LBL_ISO_CURRENCY_CODE":"ISO 4217 Currency Code",
    "LBL_SEPERATOR":"1000s Separator",
    "LBL_DECIMAL_SYMBOL":"Decimal Symbol",
    "LBL_EXPORT_SETTINGS":"Export Settings",
    "LBL_EXPORT_DELIMITER":"Export Delimiter",
    "LBL_EXPORT_CHARACTOR":"Default Export Character Set",
    "LBL_DESABLE_EXPORT":"Disable export",
    "LBL_ADMIN_EXPORT_ONLY":"Admin export only",
    "LBL_PAGE_SETTINGS":"Page Setting",
    "LBL_PAGE_FORMAT":"Page Format",
    "LBL_PAGE_ORIENTATION":"Page Orientation",
    "LBL_HEADER_SETTING":"Header Setting",
    "LBL_HEADER_TITLE":"Header Title",
    "LBL_HEADER_SUBTITLE":"Header Subtitle",
    "LBL_HEADER_LINE_2":"Header Line 2",
    "LBL_HEADER_LINE_3":"Header Line 3",
    "LBL_HEADER_LINE_4":"Header Line 4",
    "LBL_HEADER_LINE_5":"Header Line 5",
    "LBL_TITLE_QUOTE":"Title Quote",
    "LBL_DOCUMENT_NUMBER":"Document No.",
    "LBL_PAGE_MARGINS":"Page Margins",
    "LBL_HEADER_MARGIN":"Header Margin",
    "LBL_FOOTER_MARGIN":"Footer Margin",
    "LBL_TOP_MARGIN":"Top Margin",
    "LBL_BOTTOM_MARGIN":"Bottom Margin",
    "LBL_LEFT_MARGIN":"Left Margin",
    "LBL_RIGHT_MARGIN":"Right Margin",
    "LBL_FONT_SETTINGS":"Font Setting",
    "LBL_HEADER_FONT_FAMILY":"Header Font Family",
    "LBL_HEADER_FONT_FAMILY_SIZE":"Size",
    "LBL_DATA_FONT_FAMILY":"Data Font Family",
    "LBL_DATA_FONT_FAMILY_SIZE":"Size",
    "LBL_PDF_LOGO_SETTING":"Pdf Logo Setting",
    "LBL_UPLOAD_LOGO":"Upload Logo",
    "LBL_UPLOAD_NABH_LOGO":"Upload Nabh Logo",
    "LBL_PDF_LOGO_WIDTH":"Logo Width",
    "LBL_PDF_LOGO_HEIGHT":"Logo Height",
    "LBL_LOGIN_PAGE":"Login Page Settings",
    "LBL_LOGIN_LOGO_IMAGE":"Login Logo Image",
    "LBL_LOGIN_BACKGROUND_IMAGE":"Login Background Image",
    "LBL_CLEAR_CACHE":"Clear Cache & Cache Files",
    "LBL_CLEAR_BLADE":"Clear blade files",
    "LBL_CLEAR_CLASSES":"Clear optimize files and cache",
    "LBL_CLEAR_ROUTE":"Clear URL cache",
    "LBL_USER_DASHLETS":"User Default Dashlets",
    "login_with_captcha":"Login With Captcha",
    "two_factor_authentication":"Two Factor Authentication",
    "no_allow_user_login":"Number Of Allowed Uesr Login",
    "LBL_COUNTRY_LISTS":"Country Lists",
    "LBL_SYSTEM_MANAGEMENT":"System Management",
    "LBL_CREATE_FUNDER":"Add Funder",
    "LBL_VIEW_FUNDER":"View Funder",
    "LBL_CREATE_BRANCH":"Add Branch",
    "LBL_VIEW_BRANCH":"View Branch",
    "LBL_CREATE_ROLE":"Add Role",
    "LBL_VIEW_ROLE":"View Role",
    "LBL_COPY_ROLES":"Copy Roles",
    "LBL_MODIFY_ROLE":"Modify Role",
    "LBL_CREATE_BUDGETHEAD":"Add Budget Head",
    "LBL_VIEW_BUDGETHEAD":"View Budget Head",
    "LBL_CREATE_BUDGETSUBHEAD":"Add Budget Sub Head",
    "LBL_VIEW_BUDGETSUBHEAD":"View Budget Sub Head",
    "LBL_CREATE_MULTIBRANCH":"Add Muti Branch",
    "LBL_VIEW_MULTIBRANCH":"View Multi Branch",
    "":"Settings",
}

export default language;